import { PRODUCT_PRICING_STATES } from '@app/api/constants'
import { PRODUCT_PRICING_STATES_TITLE } from '@app/pages/TransferResultsPage/constants'

export const FILTER_STATE_OPTIONS = [
  {
    label: PRODUCT_PRICING_STATES_TITLE.DONE,
    value: PRODUCT_PRICING_STATES.DONE
  },
  {
    label: PRODUCT_PRICING_STATES_TITLE.PENDING,
    value: PRODUCT_PRICING_STATES.PENDING
  },
  {
    label: PRODUCT_PRICING_STATES_TITLE.PROCESSING,
    value: PRODUCT_PRICING_STATES.PROCESSING
  }
]
